export default "__VITE_ASSET__5e4a84e3__"